import axios from 'axios';
import Storage from 'localStorage';

// export const API_HOST = 'http://localhost:4000';
export const API_HOST = 'https://api-v2.seenapse.it'
// export const API_HOST = 'https://api-v2-sandbox.seenapse.it'


export const API = axios.create({ baseURL: API_HOST });


API.interceptors.request.use((config) => {
  const token = Storage.getItem('token');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});



// WEBPACK FOOTER //
// ./src/shared/constants/Constants.js